"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateField = {
    name: 'ScDateField',
    functional: true,
    props: {
        field: {
            type: Object,
            required: true,
        },
        tag: {
            type: String,
        },
        editable: {
            type: Boolean,
            default: true,
        },
        // Hopefully this PR will negate having to cast the formatter prop
        // to PropOptions<any>: https://github.com/vuejs/vue/pull/6856
        formatter: {
            type: Function,
            default: undefined,
        },
    },
    // Need to assign `any` return type because Vue type definitions are inaccurate.
    // The Vue type definitions set `render` to a return type of VNode and that's it.
    // However, it is possible to return null | string | VNode[] | VNodeChildrenArrayContents.
    render: function (createElement, context) {
        var _a = context.props, field = _a.field, editable = _a.editable, formatter = _a.formatter, tag = _a.tag;
        if (!field || (!field.editable && !field.value)) {
            return null;
        }
        // In functional components, context.data should be passed along to the
        // `createElement` function in order to retain attributes and events
        // https://vuejs.org/v2/guide/render-function.html#Passing-Attributes-and-Events-to-Child-Elements-Components
        var data = __assign({}, context.data);
        var children;
        if (field.editable && editable) {
            data.domProps = __assign(__assign({}, data.domProps), { innerHTML: field.editable });
        }
        else if (context.data.scopedSlots && context.data.scopedSlots.default) {
            // if default slot is defined, pass it the date value and use the output as the return value for the `render` function.
            // note: the output of the scoped slot _should_ be a VNode or VNode array.
            var output = context.data.scopedSlots.default(field.value ? new Date(field.value) : null);
            return output;
        }
        else if (formatter) {
            children = formatter(field.value ? new Date(field.value) : null, createElement);
        }
        else {
            children = field.value;
        }
        return createElement(tag || 'span', data, children);
    },
};
